import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import wingStop from "../assets/images/wingStop-logo.png";
import gift from "../assets/images/gift.png"
import star from "../assets/images/star.png"
import Header from "../components/Header";
import {formatDate} from "../utils/helper";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";
import PageLoader from "../components/PageLoader";


const Points = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [points, setPoints] = useState([]);
  const [isLoader, setIsLoader] = useState([]);

  const getPoints = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: "/getUserLoyalty",
      });
      const data = response.data;

      if (data.status) {
        setPoints(data.data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Dashboard loading error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  useEffect(() => {
      getPoints();
  }, []);

  return (
    <div className="">
      {isLoader ?(
        <PageLoader />
      ):(
        <div className="main-heading container loyality-points" >
          
          <Header title={'Loyality Points'} />
          

          <div className="card m-3">
            <div className="card-bg">
              <div className="d-flex justify-content-between">
                <h3>{user?.name}</h3>
                <img src={wingStop} alt="logo" style={{width: "150px", marginTop: "10px"}} />
              </div>
              <h2>{points.loyalty_points} Points</h2>
              <p>{points.loyalty_code}</p>
            </div>
          </div>

          <div className="loyalty-container">
            {/* <div className="text-center">
              <div className="qr-sec mx-auto">
                <img src={points.qrImage} alt="QR Code" />
              </div>
            </div> */}

            <div className="points-box ">
              <div className="card-box d-flex align-items-center gap-3 shadow-sm">
                <img src={star} alt="Gift" className="gift" />

                <div>
                  <h5 className="m-0 fw-bold">{points.loyalty_points} PTS</h5>
                  <small className="text-muted">Total available points</small>
                </div>
              </div>
              <div className="card-box d-flex align-items-center gap-3 shadow-sm mt-3">
                <img src={gift} alt="Gift" className="gift" />
                <div>
                  <h5 className="m-0 fw-bold">{points.loyalty_points/points.aed_points} AED</h5>
                  <small className="text-muted">1 AED = {points.aed_points} Loyalty Points</small>
                </div>
              </div>
              <div className="learn-more text-success fw-semibold mt-3">
                Learn About Points
              </div>
            </div>

            <div className="history px-3 mt-4">
              <h5 className="fw-bold">Point History</h5>

              {points.history && points.history.map((history) => (
                <div className="history-item d-flex justify-content-between align-items-center mt-3">
                  <div className="d-flex align-items-center gap-3">
                    <img src={history.image} alt="Combo" className="history-img" />
                    <div>
                      <div className="fw-semibold">{history.title}</div>
                      <small className="text-muted">{formatDate(history.createdAt,'DD MMM, YY hh:mm A')}</small>
                    </div>
                  </div>
                  <span className={`fw-bold ${(history.points_type=="reward")?"text-success":"text-danger"} `}>{(history.points_type=="reward")?"+":"-"}{history.loyalty_points}</span>
                </div>
              ))}

            
            </div>


          </div>
        </div>
      )}
    </div>
  );
};

export default Points;
